import { AxiosResponse } from 'axios';
import endpoints from 'constants/endpoints';
import { ApiSaleOrderService, ApiService } from 'services';
import {
	ISaleOrderEnvelope,
	IETicketServiceEnvelope,
	ITransactionFullDetailApiResponse,
	ITransactionFullDetails,
} from './types';
import { mapTransactionFullDetailResponse } from './mappers';

export const getTransactionFullDetail = (id: number): Promise<AxiosResponse<ITransactionFullDetailApiResponse>> =>
	ApiService.get(`${endpoints.transactions}/${id}/full-detail`);

// Obtener Sale Order por Deal ID
export const getSaleOrderByDealId = (dealId: number): Promise<AxiosResponse<ISaleOrderEnvelope>> =>
	ApiSaleOrderService.get('/saleorders', {
		params: {
			page: 1,
			size: 10,
			sort: '-created',
			dealId,
			envelope: true,
		},
	});

// Obtener servicio/info por E-Ticket
export const getServiceByETicket = (eticket: string): Promise<AxiosResponse<IETicketServiceEnvelope>> =>
	ApiSaleOrderService.get('/flight-and-flight-ancillary-eticket-summaries', {
		params: {
			page: 1,
			size: 10,
			sort: '-serviceCreatedAt',
			eTicket: eticket,
			envelope: true,
		},
	});

// Cargar info completa de la transacción (endpoint consolidado full-detail)
export const getTransactionFullDetails = async (transactionId: number): Promise<ITransactionFullDetails> => {
	const fullDetailResponse = await getTransactionFullDetail(transactionId);
	const { transaction, authorizations, finalizationsData } = mapTransactionFullDetailResponse(fullDetailResponse.data);

	let saleOrder = null;
	try {
		const saleOrderResponse = await getSaleOrderByDealId(transaction.transactionData.crmTicket);
		if (saleOrderResponse.data?.elements?.length > 0) {
			saleOrder = saleOrderResponse.data.elements[0];
		}
	} catch (error) {
		console.warn('No se pudo cargar la Sale Order principal', error);
	}

	return {
		transaction,
		saleOrder,
		authorizations,
		finalizationsData,
	};
};
